export default __webpack_public_path__ + "static/media/prize-3-cn.a07c2ca2.webp";